import {Injectable} from '@angular/core';
import {INGXLoggerMetadata, NgxLoggerLevel, NGXLoggerServerService} from 'ngx-logger';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AppInjector} from './app-injector';
interface CustomLoggerMetadata extends INGXLoggerMetadata {
  levelName?: string;
  userName?: string;
  deviceInfo?: string;
}
@Injectable()
export class ServerCustomizedService extends NGXLoggerServerService {

  override customiseRequestBody(metadata: INGXLoggerMetadata): any {
    const body: CustomLoggerMetadata = { ...metadata };
    body['levelName'] = NgxLoggerLevel[metadata.level].toLowerCase();

    if ( localStorage.getItem('loginUserId')) {
      // @ts-ignore
      body['userName'] = localStorage.getItem('loginUserId');
    }
    const injector = AppInjector.getInjector();
    const deviceService = injector.get(DeviceDetectorService);
    // @ts-ignore
      body['deviceInfo'] = JSON.stringify(deviceService.getDeviceInfo());
    // @ts-ignore
      body['typeOfDevice'] = this.detectDeviceType();
    return {logEvent: body};
  }

  private detectDeviceType(): string {
    const injector = AppInjector.getInjector();
    const deviceService = injector.get(DeviceDetectorService);
    if (deviceService.isMobile()) {
      return  'Mobile';
    } else if (deviceService.isTablet()) {
      return  'Tablet';
    } else if (deviceService.isDesktop()) {
      return  'Desktop';
    } else {
      return'Unknown';
    }
  }
}
